<template>
  <div v-if="!loaded" class="text-center">Chargement ...</div>
  <div v-else>
    <div class="w-full table-wrapper price-list p-2 bg-gray-50 border border-gray-300 rounded">
      <div class="grid grid-cols-2 mb-2">
        <div class="col-span-1">
          <h2 class="font-bold">Client</h2>
          <p>
            {{ client.name }}
            <span class="block text-indigo-800" v-if="client.phone">
              <a :href="`tel:${client.phone}`">{{ client.phone }}</a>
            </span>
          </p>
        </div>
        <div class="col-span-1">
          <UIAtomSelectStage class="ml-auto mb-2" v-model="production"></UIAtomSelectStage>
          <div class="ml-auto inline text-right pt-4">
            <h2 class="font-bold">Description</h2>
            <p>{{ description || 'qsdqsd' }}</p>
          </div>
        </div>
      </div>
      <table class="w-full" cellpadding="0" cellspacing="0">
        <thead v-if="products?.length && found">
          <tr class="heading bg-gray-300">
            <td>Produit</td>

            <td style="width: 60px">Quantité</td>

            <td style="width: 60px">Longeur</td>

            <td style="width: 60px">Largeur</td>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!products?.length || !found">
            <td colspan="4" style="text-align: center" class="p-0 text-xs text-gray-400">Rien retrouvé</td>
          </tr>
          <tr class="item border-b-0" v-for="(p, index) in products" :key="JSON.stringify(p) + index">
            <td>
              <span class="font-bold bg-gray-200 px-2 py-1 rounded mr-2">Code: {{ p.code }}</span> {{ p.description }}
            </td>
            <td style="width: 60px">{{ p.quantity }}</td>
            <td style="width: 60px">{{ p.length || '/' }} <span v-if="p.length > 0">M</span></td>
            <td style="width: 60px">{{ p.width || '/' }} <span v-if="p.width > 0">M</span></td>
          </tr>
          <tr v-for="p in pictures" :key="p">
            <td colspan="4">
              <img :src="p" style="max-width: 40vh" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue'
import UIAtomSelectStage from '@/components/UI/Atom/SelectStage.vue'
import useApi from '@/hooks/useApi'

const props = defineProps({
  id: {
    type: [Number, String],
  },
})

const api = useApi()
const production_id = computed(() => props.id)

const loaded = ref(false)
const found = ref(false)

const products = ref([])
const client = ref({})
const description = ref('')
const pictures = ref([])

const production = ref({ id: null, stage: 'BACKLOG' })

if (production_id.value) {
  api.production
    .get({ production_id: production_id.value })
    .then(res => {
      // console.log({ res })
      products.value = res?.data?.products || []
      client.value = res?.data?.client || {}
      description.value = res?.data?.doc?.description || ''
      found.value = true
      production.value.id = production_id.value
      production.value.stage = res?.data?.doc?.stage
      const doc = res?.data?.doc
      if (doc) {
        api.files
          .list({
            doc_number: (doc.type === 'INVOICE' && doc.doc_number_linked) || doc.doc_number,
            type: doc.type === 'INVOICE' && doc.doc_number_linked ? 'QUOTE' : doc.type,
          })
          .then(({ data }) => {
            pictures.value = data?.list || {}
          })
      }
      return res
    })
    .finally(() => {
      loaded.value = true
    })
}
</script>

<style scoped>
.document-layout .price-list tr td {
  padding: 5px;
  text-anchor: middle;
  vertical-align: middle;
}
</style>
